import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Form } from "../../../components/ui/common/form";
import { FormSearchSelect } from "../../../components/ui/Input/FormSearchSelect";

interface EmptyStateProps {
  form: UseFormReturn<{ salesUnitId: string }>;
  options: Array<{ id: string; title: string; value: string }>;
  isLoading: boolean;
  onChangeValue: (value: string) => void;
}

/**
 * EmptyState Component
 * Single Responsibility: Display when no product is selected
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  form,
  options,
  isLoading,
  onChangeValue
}) => {
  return (
    <div className="tw-p-1 tw-bg-white">
      <Form {...form}>
        <FormSearchSelect
          control={form.control}
          name="salesUnitId"
          label="Product Name"
          placeholder="Search products..."
          options={options}
          disabled={isLoading}
          loading={isLoading}
          required={false}
          onChange={onChangeValue}
        />
      </Form>
      <h1 className="tw-mt-1">Please select your product.</h1>
    </div>
  );
};
